import { render, staticRenderFns } from "./DadoConteudo.vue?vue&type=template&id=3eed4671&scoped=true"
import script from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DadoConteudo.vue?vue&type=style&index=0&id=3eed4671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eed4671",
  null
  
)

export default component.exports